import {ChangeDetectorRef, Component, computed, effect, inject, input, signal,} from '@angular/core';
import {GoogleMap, MapAdvancedMarker} from '@angular/google-maps';
import {DadosLocalizacaoDemanda} from '@core/models/demanda';
import {GoogleMapsLoaderService} from '@core/services/google-maps-loader.service';
import {MapaDemandasService} from '@core/services/mapa-demandas.service';
import {TipoObraService} from '@core/services/tipo-obra.service';
import {environment} from '@environments/environment';
import {
  InputSelectTipoObra
} from '@pages/demandas/adicionar-demanda/input-select-tipo-obra/input-select-tipo-obra.component';
import {DatePtbrPipe} from '@shared/pipes/date-format.pipe';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-dados-localizacao-demanda',
  standalone: true,
  imports: [
    GoogleMap,
    MapAdvancedMarker,
    InputSelectTipoObra,
    DatePtbrPipe,
    NgClass,
  ],
  templateUrl: './dados-localizacao-demanda.component.html',
  styleUrl: './dados-localizacao-demanda.component.css',
  host: {
    '[class.mapa-flex]': 'mapaAlturaDinamica()',
  },
})
export class DadosLocalizacaoDemandaComponent {
  showMapa = input.required<boolean>();
  showTipoObra = input.required<boolean>();
  showData = input(false);
  mapaAlturaDinamica = input(false);
  tipoObraId = input<number | null>();
  dadosLocalizacao = input.required<DadosLocalizacaoDemanda | null>();

  protected readonly mapId = environment.google.mapId;
  protected zoom = 12;
  protected center: google.maps.LatLngLiteral = {
    lat: -23.5505,
    lng: -46.6333,
  };
  protected mapOptions: google.maps.MapOptions = {};
  protected readonly isMapaCarregado = signal(false);

  protected readonly posicaoPinSelecionado =
    computed<google.maps.LatLngLiteral | null>(() => {
      const dados = this.dadosLocalizacao();
      if (!dados?.latitude || !dados?.longitude) return null;
      const lat = dados.latitude;
      const lng = dados.longitude;
      return Number.isNaN(lat) || Number.isNaN(lng) ? null : {lat, lng};
    });

  protected readonly pinSelecionadoContent = computed(() => {
    this.tipoObraService.iconesCarregados();
    return this.tipoObraService.buildPinIcon(this.tipoObraId() ?? undefined);
  });

  private readonly googleMapsLoader = inject(GoogleMapsLoaderService);
  private readonly mapaDemandasService = inject(MapaDemandasService);
  private readonly tipoObraService = inject(TipoObraService);
  private readonly cdr = inject(ChangeDetectorRef);

  constructor() {
    effect(() => {
      const dados = this.dadosLocalizacao();
      if (!dados) return;
      const lat = dados.latitude ?? null;
      const lng = dados.longitude ?? null;
      if (lat && lng) {
        this.center = {lat, lng};
      }
    });

    effect(() => {
      if (this.showMapa()) {
        this.googleMapsLoader.load().then(() => this.isMapaCarregado.set(true));
      }
    });
  }

  onMapInitialized(map: google.maps.Map): void {
    this.mapOptions = this.mapaDemandasService.buildMapOptions();
    this.mapOptions = {
      ...this.mapOptions,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false
    };
    this.cdr.detectChanges();
    this.mapaDemandasService.drawContornoSaoPaulo(map);
  }

}
